// extracted by mini-css-extract-plugin
module.exports = {"container":"UserMenu_container__2WRLd","message":"UserMenu_message__3KcJq"};